import React from "react";
import { Users } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * ProfileSwitcher — tabs across configured profiles.
 * Props:
 *   profiles : analyses.results.profiles[]
 *   activeId : current profile_id
 *   onChange(profile_id)
 */
export default function ProfileSwitcher({ profiles = [], activeId, onChange }) {
  if (!profiles?.length) return null;
  return (
    <div
      className="flex items-center gap-2 overflow-x-auto scrollbar-sleek"
      role="tablist"
      aria-label="Sélecteur de profil contribuable"
      data-testid="profile-switcher"
    >
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-muted-foreground">
        <Users className="h-3.5 w-3.5" />
        Profil&nbsp;:
      </div>
      {profiles.map((p, i) => {
        const isActive = p.profile_id === activeId;
        return (
          <button
            key={p.profile_id || i}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(p.profile_id)}
            data-testid={`profile-switcher-btn-${p.profile_id}`}
            className={cn(
              "group rounded-full border px-3 py-1.5 text-sm font-medium transition-colors",
              isActive
                ? "border-brand-gold bg-primary text-primary-foreground shadow-sm"
                : "border-border bg-card hover:border-brand-gold/60 hover:bg-accent/40"
            )}
          >
            {p.profile_name || `Profil ${i + 1}`}
          </button>
        );
      })}
    </div>
  );
}
